/**
 * Images are stored in app/assets/images/landing/video-previews folder, but here should only be filename.
 * all images should have .jpg extension.
 * add preview image for retina, you need add file with sufix _2x.
 * image size should be 320x180 and for _2x(retina) 640x360
 */

interface Video {
    name?: string;
    preview?: string;
    youtube?: string;
}

interface VideoStore {
    [yutubeId: string]: Video;
}

const videos: VideoStore = {
    'h0iARjYhbHY': {
        name: 'Animatron Product Demo'
    },
    'yvKVLFBk7MU': {
        name: 'How To Bait Your Hook'
    },
    '3nvvjdpvVwE': {
        name: 'Anatomy of a Script'
    },
    '0UsaRxqEFnE': {
        name: 'Collaborative Learning'
    },
    '4jtMLJR7YVE': {
        name: 'Animatron - Banner Ad Explainer Video',
        preview: 'Animatron_Explainer_Video'
    },
    'uQ_w0Y8YFJY': {
        name: 'Silent Explainer Video'
    },
    'NU-0qpoD7Yk': {
        name: 'Whiteboard animation',
        preview: 'whiteboard'
    },
    '13mGg5gmPL4': {
        name: 'How to Create Whiteboard Animation with Animatron'
    },
    'TxyPmfybDlw': {
        name: 'Year End Sale Video'
    },
    'rt5_OHiqxbA': {
        name: 'A Promo Video for an Online Teacher',
        preview: 'Teacher_demo'
    },
    '5lmn5G2SM1Q': {
        name: 'Promo video',
        preview: 'Brooklyn'
    },
    'nL8KXi-Ebpg': {
        name: 'Short ads',
        preview: 'short_ads'
    },
    'Hsb8Hnxnyyw': {
        name: 'Social media videos',
        preview: 'social'
    },
    '4ZNaLnVaGj8': {
        name: 'Event promo video',
        preview: 'Wine'
    },
    'Vm_W4CX72rw': {
        name: 'Website Promo',
        preview: 'Mountains'
    },
    '8Rq75fMP8v8': {
        name: 'Real Estate Ad',
        preview: 'Real_Estate'
    },
    'UjmaE78NyB4': {
        name: 'Bakery Promo Video',
        preview: 'Bakery'
    },
    'LhyXWD-Ua-w': {
        name: 'Fashion',
        preview: 'Fashion'
    },
    'pw4b7fmh5u': {
        preview: 'like_croissants',
    },
    'k61bau7oyd': {
        preview: 'looking_for_house',
    },
    'twoktydxrp': {
        preview: 'truffaldino',
    }
};

export class VideoGallery {
    videosIds: string[];
    videos = this.getVideos();
    player: string = this.player || 'youtube';
    viewMode: string = this.viewMode || 'border';

    getPreviewUrl(fileName: string) {
        try {
            return require(`../../../images/landing/video-previews/${fileName}_2x.jpg`);
        } catch (e) {
            _.notification.showError(e);
            console.error(e);
            return '';
        }
    }

    getVideos() {
        return this.videosIds.map((videoId: string) => {
            let v = videos[videoId];
            if (v) {
                return Object.assign({}, v, {
                    videoId,
                    preview: v.preview || v.name.replace(/ /g, '_')
                });
            } else {
                return {videoId};
            }
        });
    }
}

angular.module('animatronApp.videoGallery', [])
    .component('videoGallery', {
        bindings: {
            videosIds: '<',
            viewMode: '@',
            player: '@'
        },
        controller: VideoGallery,
        templateUrl: require('landing/video-gallery.html')
    });


// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/landing/VideoGallery.ts